import React from 'react';
import PaymobLogo from './../../../../../statics/img/esaypaisa/paymob.png';
import Declined from './../../../../../statics/img/card/declined_payment.gif';

function DeclinedPayment(props) {
    return (
        <div className="payment_status_container declined">
            <span>Cancel</span>
            <img src={Declined} />
            <h3>Payment declined</h3>
            <p>{props.paymet_error_message ? props.paymet_error_message : "Something went wrong, Please try again"}</p>
            <div className="content">
                <button>Try again</button>
            </div>
            <div className="footer">
                <span>Powered by</span>
                <img src={PaymobLogo} />
            </div>
        </div>
    )
}

export default DeclinedPayment;